import { type ExtensionApi } from './extension';
import { View } from './View';
import type { ExternalLayer, ExternalLayerSpec } from './layer';
import { getLayer } from '../layer';

export interface Spec {
  /** 图层，类似 echarts 中的 series 概念，但比 series 抽象程度更高 */
  layers: ExternalLayerSpec[];
}

export class ExternalView extends View {
  private __destroyFunc!: () => void;

  render(api: ExtensionApi, $container: HTMLElement, spec: Spec) {
    const globalLayoutInfo = api.hook.layout(api);
    const { layers = [] } = spec;

    if (globalLayoutInfo.mainView.hasIndependentLayer && layers.length > 1) {
      throw new Error('Multiple `independent` layers are not supported.');
    }

    const layer = layers[0];
    const layerDefine = getLayer(layer.type) as ExternalLayer;

    this.__destroyFunc = layerDefine.render(api, layer, $container);
  }

  destroy() {
    this?.__destroyFunc?.();
  }
}
